import React from 'react';
import './TextContent.css';

import TitleBar from '../../TitleBar/TitleBar';

const TextContent = ({
    type = 'light',
    title = '',
    content = '',
    id = ''
}) => {
    return (
        <>
            <section id={id || undefined} className={ type === 'dark' ? "text-content dark" : "text-content"}>
                <TitleBar title={title} type={type} /> 
                <div className="view-container">
                    <div className="half-box">
                        {content}
                    </div>
                </div>
            </section>
        </>
    )
}

export default TextContent;